/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PropertySharingFieldPart } from './PropertySharingFieldPart';
import type { PropertySharingIdentifierPart } from './PropertySharingIdentifierPart';
/**
 * One preview parameter resolved without exposing arbitrary metadata.
 */
export type PropertySharingParameterValue = {
    /**
     * Template tag used to request this value.
     */
    parameter: (PropertySharingFieldPart | PropertySharingIdentifierPart);
    /**
     * Raw tag value when it can be resolved uniquely.
     */
    value: string | null;
    /**
     * Missing or conflicting input; absent when the value is available.
     */
    reason?: PropertySharingParameterValue.reason;
};
export namespace PropertySharingParameterValue {
    /**
     * Missing or conflicting input; absent when the value is available.
     */
    export enum reason {
        MISSING_PARAMETER = 'missing_parameter',
        AMBIGUOUS_IDENTIFIER = 'ambiguous_identifier',
    }
}

